<template>
    <div class="container">
        <div class="modal-header">
            <h2>CERT/ITEM #: {{ item.CertNum || item.ItemNum }}</h2>
        </div>

        <!-- Item Info Table -->
        <div class="item-info">
            <div class="info-col"><strong>Order#:</strong> {{ item.OrderNum }}</div>
            <div class="info-col"><strong>PO #:</strong> {{ item.PO }}</div>
            <div class="info-col"><strong>SKU:</strong> {{ item.SKU }}</div>
            <div class="info-col"><strong>Item Type:</strong> {{ item.Type }}</div>
        </div>
        <div class="categories-grid">

            <!-- General Category -->
            <div class="category">
                <h4>GENERAL</h4>
                <div v-for="issue in generalOptions" :key="issue" class="issue-container">
                    <label>
                        <input type="checkbox" :value="issue" v-model="formData.selectedRejections">
                        {{ issue }}
                    </label>

                    <!-- Wedding Set Checkboxes per option (Only if checked & item is a Wedding Set) -->
                    <div v-if="isWeddingSet && formData.selectedRejections.includes(issue)" class="wedding-type-group">
                        <span class="sub-label">Select Wedding Set Type(s):</span>
                        <label v-for="type in ['Ring', 'Band']" :key="type" class="checkbox-label">
                            <input type="checkbox" :value="type" v-model="selectedWeddingType[issue]">
                            {{ type }}
                        </label>
                    </div>
                </div>
            </div>

            <!-- Stone Category -->
            <div class="category">
                <h4>STONE</h4>
                <div v-for="issue in stoneOptions" :key="issue" class="issue-container">
                    <label>
                        <input type="checkbox" :value="issue" v-model="formData.selectedRejections">
                        {{ issue }}
                    </label>
                    <!-- Wedding Set Checkboxes per option (Only if checked & item is a Wedding Set) -->
                    <div v-if="isWeddingSet && formData.selectedRejections.includes(issue)" class="wedding-type-group">
                        <span class="sub-label">Select Wedding Set Type(s):</span>
                        <label v-for="type in ['Ring', 'Band']" :key="type" class="checkbox-label">
                            <input type="checkbox" :value="type" v-model="selectedWeddingType[issue]">
                            {{ type }}
                        </label>
                    </div>

                    <!-- Wedding Set Checkboxes per option (Only if checked & item is a Wedding Set) -->
                    <div v-if="isWeddingSet && formData.selectedRejections.includes(issue)" class="wedding-type-group">
                        <span class="sub-label">Select Wedding Set Type(s):</span>
                        <label v-for="type in ['Ring', 'Band']" :key="type" class="checkbox-label">
                            <input type="checkbox" :value="type" v-model="selectedWeddingType[issue]">
                            {{ type }}
                        </label>
                    </div>

                    <div v-if="cntInputData[issue] && specialResponses.includes(issue)"
                        style="width: 100%; display: flex;" class="input-group">
                        <label style="width: fit-content;">is</label>
                        <input type="text" v-model="cntInputData[issue].is" class="short-input" />
                        <label style="width: fit-content;">, should be</label>
                        <input type="text" v-model="cntInputData[issue].should" class="short-input" />
                    </div>
                </div>
            </div>

            <!-- Gemstones Category -->
            <div class="category">
                <h4>DIAMONDS</h4>
                <div v-for="issue in diamondOptions" :key="issue" class="issue-container">
                    <label>
                        <input type="checkbox" :value="issue" v-model="formData.selectedRejections">
                        {{ issue }}
                    </label>

                    <!-- Wedding Set Checkboxes per option (Only if checked & item is a Wedding Set) -->
                    <div v-if="isWeddingSet && formData.selectedRejections.includes(issue)" class="wedding-type-group">
                        <span class="sub-label">Select Wedding Set Type(s):</span>
                        <label v-for="type in ['Ring', 'Band']" :key="type" class="checkbox-label">
                            <input type="checkbox" :value="type" v-model="selectedWeddingType[issue]">
                            {{ type }}
                        </label>
                    </div>

                    <div v-if="cntInputData[issue] && specialResponses.includes(issue)"
                        style="width: 100%; display: flex;" class="input-group">
                        <label style="width: fit-content;">is</label>
                        <input type="text" v-model="cntInputData[issue].is" class="short-input" />
                        <label style="width: fit-content;">, should be</label>
                        <input type="text" v-model="cntInputData[issue].should" class="short-input" />
                    </div>
                </div>

                <h4>GEMSTONES</h4>
                <label v-for="issue in gemstoneOptions" :key="issue">
                    <input type="checkbox" :value="issue" v-model="formData.selectedRejections">
                    {{ issue }}
                </label>
            </div>

            <!-- Prongs Category -->
            <div class="category">
                <h4>PRONGS</h4>
                <div v-for="issue in prongOptions" :key="issue" class="issue-container">
                    <label>
                        <input type="checkbox" :value="issue" v-model="formData.selectedRejections">
                        {{ issue }}
                    </label>

                    <!-- Wedding Set Checkboxes per option (Only if checked & item is a Wedding Set) -->
                    <div v-if="isWeddingSet && formData.selectedRejections.includes(issue)" class="wedding-type-group">
                        <span class="sub-label">Select Wedding Set Type(s):</span>
                        <label v-for="type in ['Ring', 'Band']" :key="type" class="checkbox-label">
                            <input type="checkbox" :value="type" v-model="selectedWeddingType[issue]">
                            {{ type }}
                        </label>
                    </div>

                    <div v-if="cntInputData[issue] && specialResponses.includes(issue)"
                        style="width: 100%; display: flex;" class="input-group">
                        <label style="width: fit-content;">is</label>
                        <input type="text" v-model="cntInputData[issue].is" class="short-input" />
                        <label style="width: fit-content;">, should be</label>
                        <input type="text" v-model="cntInputData[issue].should" class="short-input" />
                    </div>
                </div>
            </div>

            <!-- Setting/Metal Category -->
            <div class="category">
                <h4>SETTING</h4>
                <div v-for="issue in settingOptions" :key="issue" class="issue-container">
                    <label>
                        <input type="checkbox" :value="issue" v-model="formData.selectedRejections">
                        {{ issue }}
                    </label>

                    <!-- Wedding Set Checkboxes per option (Only if checked & item is a Wedding Set) -->
                    <div v-if="isWeddingSet && formData.selectedRejections.includes(issue)" class="wedding-type-group">
                        <span class="sub-label">Select Wedding Set Type(s):</span>
                        <label v-for="type in ['Ring', 'Band']" :key="type" class="checkbox-label">
                            <input type="checkbox" :value="type" v-model="selectedWeddingType[issue]">
                            {{ type }}
                        </label>
                    </div>

                    <div v-if="cntInputData[issue] && specialResponses.includes(issue)"
                        style="width: 100%; display: flex;" class="input-group">
                        <label style="width: fit-content;">is</label>
                        <input type="text" v-model="cntInputData[issue].is" class="short-input" />
                        <label style="width: fit-content;">, should be</label>
                        <input type="text" v-model="cntInputData[issue].should" class="short-input" />
                    </div>
                </div>
            </div>

            <div class="category">
                <h4>METAL</h4>
                <div v-for="issue in metalOptions" :key="issue" class="issue-container">
                    <label>
                        <input type="checkbox" :value="issue" v-model="formData.selectedRejections">
                        {{ issue }}
                    </label>
                    <!-- Wedding Set Checkboxes per option (Only if checked & item is a Wedding Set) -->
                    <div v-if="isWeddingSet && formData.selectedRejections.includes(issue)" class="wedding-type-group">
                        <span class="sub-label">Select Wedding Set Type(s):</span>
                        <label v-for="type in ['Ring', 'Band']" :key="type" class="checkbox-label">
                            <input type="checkbox" :value="type" v-model="selectedWeddingType[issue]">
                            {{ type }}
                        </label>
                    </div>

                    <div v-if="cntInputData[issue] && specialResponses.includes(issue)"
                        style="width: 100%; display: flex;" class="input-group">
                        <label style="width: fit-content;">is</label>
                        <input type="text" v-model="cntInputData[issue].is" class="short-input" />
                        <label style="width: fit-content;">, should be</label>
                        <input type="text" v-model="cntInputData[issue].should" class="short-input" />
                    </div>
                </div>
            </div>

            <!-- Jewelry Category -->
            <div class="category" v-if="jewelryTypesOptions[itemType]">
                <h4>{{ itemType.toUpperCase() }}</h4>
                <div v-for="issue in jewelryTypesOptions[itemType]" :key="issue" class="issue-container">
                    <label>
                        <input type="checkbox" :value="issue" v-model="formData.selectedRejections">
                        {{ issue }}
                    </label>
                    <!-- Wedding Set Checkboxes per option (Only if checked & item is a Wedding Set) -->
                    <div v-if="isWeddingSet && formData.selectedRejections.includes(issue)" class="wedding-type-group">
                        <span class="sub-label">Select Wedding Set Type(s):</span>
                        <label v-for="type in ['Ring', 'Band']" :key="type" class="checkbox-label">
                            <input type="checkbox" :value="type" v-model="selectedWeddingType[issue]">
                            {{ type }}
                        </label>
                    </div>

                    <div v-if="cntInputData[issue] && specialResponses.includes(issue)"
                        style="width: 100%; display: flex;" class="input-group">
                        <label style="width: fit-content;">is</label>
                        <input type="text" v-model="cntInputData[issue].is" class="short-input" />
                        <label style="width: fit-content;">, should be</label>
                        <input type="text" v-model="cntInputData[issue].should" class="short-input" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Footer Inputs & Sentence Compilation -->
        <div class="modal-footer-inputs">
            <div class="stamp-checkboxes" v-if="showStampInput">
                <strong>Stamp Check</strong>
                <label v-for="stamp in stampOptions" :key="stamp">
                    <input type="checkbox" :value="stamp" v-model="formData.stampIssues">
                    {{ stamp }}
                    <!-- Wedding Set Checkboxes per option (Only if checked & item is a Wedding Set) -->
                    <div v-if="isWeddingSet && formData.selectedRejections.includes(issue)" class="wedding-type-group">
                        <span class="sub-label">Select Wedding Set Type(s):</span>
                        <label v-for="type in ['Ring', 'Band']" :key="type" class="checkbox-label">
                            <input type="checkbox" :value="type" v-model="selectedWeddingType[issue]">
                            {{ type }}
                        </label>
                    </div>
                </label>
            </div>

            <div class="sentence-group">
                <label><strong>Notes:</strong></label>
                <textarea v-model="description" rows="3"
                    placeholder="Additional details or generated note..."></textarea>
            </div>

            <md-card>
                <md-card-content>
                    <MultImages @removeImage="removeImage" @uploadedImages="uploadImageForItem" :media="item.Images"
                        :item="item" />
                </md-card-content>
            </md-card>
        </div>

        <!-- Action Buttons -->
        <div class="modal-actions">
            <button style="background-color: #4fd95e !important;" class="btn-submit" v-if="!lastItem" @click="submitRejectionForALL">Save For ALL</button>
            <button class="btn-submit" @click="submitRejection">{{ lastItem ? "Save & Exit" : "Save & Next" }}</button>
        </div>
    </div>
</template>

<script>
import MultImages from "@/components/Inputs/UploadMultiple.vue";
import { db } from "@/config/firebaseInit.js";
import firebase from "firebase";

export default {
    name: 'QaRejectionModal',
    components: { MultImages },
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        existingRejections: {
            type: Array,
            default: () => []
        },
        lastItem: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        itemType() {
            return this.item && this.item.Type ? this.item.Type.replace(/\s*-.*$/, '') : '';
        },
        isWeddingSet() {
            return this.itemType === 'Wedding Set';
        },
        showStampInput() {
            return this.formData.selectedRejections.some(i => i.toLowerCase().includes("stamp"));
        },
        description: {
            get() {
                return this.getAutoGeneratedText() + this.userAddedText;
            },
            set(newValue) {
                let autoText = this.getAutoGeneratedText();
                if (newValue.startsWith(autoText)) {
                    this.userAddedText = newValue.substring(autoText.length);
                } else {
                    this.$forceUpdate();
                }
            }
        }
    },
    methods: {
        uploadImageForItem(data) {
            db.doc(`orders/${this.item.OrderNum}/items/${this.item.ItemNum}`).update({
                Images: firebase.firestore.FieldValue.arrayUnion(data),
            });
            this.item.Images.push(data);
        },
        removeImage(data, index) {
            this.item.Images.splice(index, 1);
            this.$forceUpdate();
            db.doc(`orders/${this.item.OrderNum}/items/${this.item.ItemNum}`).update({
                Images: this.item.Images,
            });
        },
        getAutoGeneratedText() {
            if (this.isWeddingSet) {
                const grouped = {};

                this.formData.selectedRejections.forEach(item => {
                    const types = this.selectedWeddingType[item] && this.selectedWeddingType[item].length > 0
                        ? this.selectedWeddingType[item]
                        : ['General'];

                    const cnt = this.cntInputData[item];
                    let textRepresentation = '';

                    if (cnt && (cnt.is || cnt.should)) {
                        textRepresentation = `${item} is ${cnt.is} and it should be ${cnt.should}`;
                    } else if (item !== 'Other') {
                        textRepresentation = item;
                    }

                    if (textRepresentation) {
                        types.forEach(type => {
                            if (!grouped[type]) grouped[type] = [];
                            if (!grouped[type].includes(textRepresentation)) {
                                grouped[type].push(textRepresentation);
                            }
                        });
                    }
                });

                if (this.showStampInput && this.formData.stampIssues.length > 0) {
                    const stampText = this.formData.stampIssues.join(', ');
                    if (!grouped['General']) grouped['General'] = [];
                    grouped['General'].push(stampText);
                }

                const lines = [];
                Object.keys(grouped).forEach(type => {
                    if (grouped[type].length > 0) {
                        const prefix = type !== 'General' ? `${type}: ` : '';
                        lines.push(`${prefix}${grouped[type].join(', ')}.`);
                    }
                });

                return lines.length > 0 ? lines.join('\n') + '\n' : '';
            }

            // Standard items non-wedding set logic
            let issues = [];
            this.formData.selectedRejections.forEach(item => {
                const cnt = this.cntInputData[item];
                if (cnt && (cnt.is || cnt.should)) {
                    issues.push(`${item} is ${cnt.is} and it should be ${cnt.should}`);
                } else if (item !== 'Other') {
                    issues.push(item);
                }
            });

            if (this.showStampInput && this.formData.stampIssues.length > 0) {
                issues.push(this.formData.stampIssues.join(', '));
            }

            return issues.length > 0 ? `${issues.join(', ')}.\n` : '';
        },
        closeModal() {
            this.$emit('close');
        },
        clearModal() {
            this.formData = {
                selectedRejections: [],
                stampIssues: [],
                description: ''
            }
            this.userAddedText = ""
            this.cntInputData = {}
            this.selectedWeddingType = {}
        },
        submitRejection() {
            this.formData.description = this.description;
            this.$emit('submit', { ...this.formData, lastItem: this.lastItem });
            this.closeModal();
        },
        submitRejectionForALL() {
            this.formData.description = this.description;
            this.$emit('submitForAll', this.formData);
            this.closeModal();
        }
    },
    data() {
        return {
            formData: {
                selectedRejections: [],
                stampIssues: [],
                description: ''
            },
            selectedWeddingType: {},
            userAddedText: "",
            cntInputData: {},
            specialResponses: [
                "Prong Count", "Millimeter Width", "Metal Type", "Metal Composition",
                "Ring Size", "Stone Size", "Stone Count", "Stone Clarity",
                "Stone Cut Grade", "Shank Height/Width", "Length/Width",
                "Necklace Length (in.)", "Backing Type", "Chain Length (in.)",
                "Post Stamp", "Backing Stamp", "Stone Color", "Stone Ratio",
                "Stone Depth", "Stone Table", "Stone Girle", "Stone Polish",
                "Stone Symmetry", "Stone Flourescense", "Stone Culet",
                "Stone mm. Width", "Stone Diameter", "Stone Diameter Variance"
            ],
            jewelryTypesOptions: {
                "Bracelet": ["Bracelet Length (in.)", "Bent Bracelet", "Broken Clasp", "Loose Clasp", "Stiff Clasp", "Bent Safety Lock", "Broken Safety Lock", "No Safety Lock", "Broken Jump Ring", "Broken Link", "Uneven Links", "Open Link", "Bent Link"],
                "Cuff Links": ["Pair Asymmetry"],
                "Earrings": ["Missing Post Stamp", "Missing Backing Stamp", "Post Stamp", "Backing Stamp", "Color Mismatch", "Pair Asymmetry", "Backing Type", "Missing Earring Backs", "Tight Earring Back", "Loose Earring Back", "Mismatched Earring Back", "Misaligned Earring Back Hole", "Broken Post", "Long Post", "Short Post", "Bent Post", "Post Not 90°", "Sharp Post Tip", "Broken Bail", "Open Bail", "Broken Jump Ring"],
                "Necklace": ["Necklace Length (in.)", "Bent Necklace", "Crooked Pendant", "Off-Center Pendant", "Broken Chain", "Broken Link", "Uneven Links", "Open Link", "Bent Link", "Open Bail", "Broken Bail", "Broken Clasp", "Loose Clasp", "Stiff Clasp", "Bent Safety Lock", "Broken Safety Lock", "No Safety Lock", "Broken Jump Ring"],
                "Pendant": ["Chain Length (in.)", "Crooked Pendant", "Off-Center Pendant", "Broken Chain", "Broken Link", "Uneven Links", "Open Link", "Bent Link", "Open Bail", "Broken Bail", "Broken Clasp", "Loose Clasp", "Stiff Clasp", "Bent Safety Lock", "Broken Safety Lock", "No Safety Lock", "Broken Jump Ring"],
                "Ring": ["Ring Size", "Shank Height/Width", "Length/Width", "Crooked/Tilted Head", "Not Round", "Sharp Edge", "Distorted After Resizing"],
                "Wedding Set": ["Ring Size", "Shank Height/Width", "Length/Width", "Crooked/Tilted Head", "Not Round", "Sharp Edge", "Distorted After Resizing"],
            },
            generalOptions: ["Product Does Not Match Photo", "Size", "Millimeter Size", "Overall Asymmetry", "Other"],
            stoneOptions: ['Stone Count', 'Stone Size', 'Chipped Stone', 'Cracked Stone', 'Loose Center Stone', 'Loose Side Stones', 'Loose Stones', 'Off-Center Stone', 'Crooked or Tilted Stone', 'Missing Stone', 'Uneven Stone Height', 'Stone Size Mismatch', 'Table Not Level', 'Scratched Table', 'Chipped Girdle'],
            diamondOptions: ['Stone Clarity', 'Stone Cut Grade', "Stone Color", "Stone Ratio", "Stone Depth", "Stone Table", "Stone Girle", "Stone Polish", "Stone Symmetry", "Stone Flourescense", "Stone Culet", "Stone mm. Width", "Stone Diameter", "Stone Diameter Variance", 'Eye-Visible Inclusion'],
            gemstoneOptions: ['Low Gemstone Luster', 'Pearl Detached from Peg'],
            prongOptions: ['Prong Count', 'Bent Prong', 'Broken Prong', 'Weak Prong', 'Long Prong', 'Short Prong', 'Prong Too Long', 'Prong Too Short', 'Prong Over-Covering', 'Uneven Prongs', 'Gap Between Prong and Stone', 'Sharp Prong Tip'],
            settingOptions: ["Basket Too Deep", "Basket Too Shallow", "Uneven Basket", "Uneven Spacing", "Crooked Channel", "Uneven Tension"],
            stampOptions: ['No Metal Stamp', 'No MFG Stamp'],
            metalOptions: ["Millimeter Width", "Metal Type", "Metal Composition", "Missing Stamp", "Stamp", "Broken Metal", "Cracked Metal", "Bad Rhodium", "White Spots", "Eye-Visible Scratches", "Polishing Marks", "Pinhole/Pit", "Porosity", "Rough Area", "Toolmark", "Gouge", "Poor Polishing", "Poor Soldering", "Excess Metal", "Structural Integrity", "Sharp Edge"]
        };
    },
    watch: {
        existingRejections(data) {
            this.formData.selectedRejections = [...data];
        },
        "formData.selectedRejections": {
            deep: true,
            handler(newData) {
                newData.forEach(issue => {
                    if (!this.cntInputData[issue]) {
                        this.$set(this.cntInputData, issue, { is: "", should: "" });
                    }
                    if (this.isWeddingSet && !this.selectedWeddingType[issue]) {
                        this.$set(this.selectedWeddingType, issue, []);
                    }
                });
            }
        }
    }
};
</script>

<style scoped>
.container {
    background: #fff;
    width: 90%;
    max-width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    padding: 20px;
    border-radius: 8px;
    font-family: Arial, sans-serif;
}

.modal-header {
    border-bottom: 2px solid #ccc;
    padding-bottom: 10px;
    margin-bottom: 15px;
    position: relative;
}

.modal-header h2,
.modal-header h3 {
    margin: 0;
}

.item-info {
    display: flex;
    justify-content: space-around;
    background-color: #253C6E;
    padding: 10px;
    border: 1px solid #ddd;
    color: white;
}

.categories-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 15px;
    margin-bottom: 20px;
}

.category h4 {
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
    margin-bottom: 10px;
    background-color: #253C6E;
    color: white;
    text-align: center;
    padding-top: 5px;
}

.category label {
    display: block;
    font-size: 13px;
    margin-bottom: 4px;
}

.issue-container {
    margin-bottom: 8px;
}

.wedding-type-group {
    margin-left: 15px;
    padding-left: 8px;
    border-left: 2px solid #253C6E;
    margin-top: 4px;
}

.sub-label {
    font-size: 11px;
    font-weight: bold;
    color: #555;
    display: block;
}

.modal-footer-inputs {
    border-top: 2px solid #ccc;
    padding-top: 15px;
    margin-bottom: 20px;
}

.input-group,
.stamp-checkboxes,
.sentence-group {
    margin-bottom: 15px;
}

.short-input {
    width: 30px;
    margin: 0 10px;
    padding: 4px;
    border: none;
    border-bottom: 1px solid black;
}

.stamp-checkboxes label {
    margin-right: 15px;
    font-size: 14px;
}

.sentence-group textarea {
    width: 100%;
    padding: 8px;
    margin-top: 5px;
}

.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.btn-submit {
    background: #d9534f;
    color: #fff;
    border: none;
    padding: 10px 15px;
    border-radius: 4px;
    cursor: pointer;
}
</style>